import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatatableComponent } from './datatable.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CellTemplateDirective } from './cell-template.directive';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { PaginationComponent } from './pagination/pagination.component';
import { InputSelectModule } from '../input-select/input-select.module';
import { MaterialModule } from 'src/app/shared/material.module';
import { CustomPaginatorIntl } from './custom-paginator.component';

@NgModule({
  declarations: [
    DatatableComponent,
    CellTemplateDirective,
    PaginationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    InputSelectModule,
  ],
  exports: [DatatableComponent, CellTemplateDirective],
  providers: [{ provide: MatPaginatorIntl, useClass: CustomPaginatorIntl }]
})
export class DatatableModule {}
